import { Button, Form, InputGroup } from "react-bootstrap";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave } from "@fortawesome/free-solid-svg-icons";

function BlockName({ name, setName, updateHandler }) {

    const [edit, setEdit] = useState(false);
    const [formName, setFormName] = useState(false);

    useEffect(() => {
        setFormName(name);
    }, [name]);

    return (
        <>
            {edit === false ? (
                <div className="modal_subtitle text-center mb-15" style={{ cursor: "pointer" }} onClick={() => setEdit(true)}>{formName === null ? "Без названия..." : formName}</div>
            ) : (
                <InputGroup >
                    <Form.Control
                        placeholder="Название..."
                        onChange={(e) => { e.target.value === '' ? setName(null) : setName(e.target.value); setFormName(e.target.value) }} defaultValue={formName}
                    />
                    <Button variant="outline-success" onClick={() => { updateHandler(name); setEdit(false); }}>
                        <FontAwesomeIcon icon={faSave} />
                    </Button>
                </InputGroup>
            )}
        </>
    )
}

export default BlockName;